
// import $ from 'jquery';
// import Swiper from 'swiper/bundle';
// import 'swiper/css';
import VanillaTilt from 'vanilla-tilt';
import Lenis from '@studio-freight/lenis'
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
// import * as THREE from "three";

const breakPoint = 768;
const smartBreakPointMediaQuery = "(min-width: " + breakPoint + "px)";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

const isSmartPhone = () => {
  if (window.matchMedia && window.matchMedia('(max-device-width: ' + breakPoint + 'px)').matches) {
    return true;
  } else {
    return false;
  }
};


/**
 * @desc 一文字づつ文字をラップする
 * @param {*} target 
 * @returns 一文字つづspanでラップしたテキスト
 */
const spanWrapText = (target) => {
  const nodes = [...target.childNodes]; // ノードリストを配列にする
  let returnText = ''; // 最終的に返すテキスト

  for (const node of nodes) {
    if (node.nodeType == 3) {
      //テキストの場合
      const text = node.textContent.replace(/\r?\n/g, ''); //テキストから改行コード削除
      const splitText = text.split(''); // 一文字ずつ分割
      for (const char of splitText) {
        returnText += `<span>${char}</span>`; // spanタグで挟んで連結
      }
    } else {
      returnText += node.outerHTML;
    }
  }
  return returnText;
};

const spanWrapTextElements = document.querySelectorAll('.js-spanwrap')
if (spanWrapTextElements) {
  // console.log(spanWrapTextElements)
  spanWrapTextElements.forEach((spanWrapTextElement) => {
    spanWrapTextElement.innerHTML = spanWrapText(spanWrapTextElement)
  });
}

// Lenis Initialization
const initLenis = function () {
  const lenis = new Lenis({
    lerp: 0.1,
  });

  lenis.on("scroll", ScrollTrigger.update);

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });
}

// Hero Animation
const initHeroAnimation = () => {
  const tl = gsap.timeline({
    defaults: { ease: "power2.out" }
  });

  // Use fromTo to ensure initial state is animated gracefully without needing CSS adjustments
  tl.fromTo('.hero__logo',
    { autoAlpha: 0, scale: 0.9 },
    { autoAlpha: 1, scale: 1, duration: 1.2, ease: "back.out(1.2)" }
  )
    .fromTo('.hero__lead2-text',
      { autoAlpha: 0, y: 30 },
      { autoAlpha: 1, y: 0, duration: 0.8, stagger: 0.2 },
      "-=0.6"
    )
    .fromTo('.hero__info',
      { autoAlpha: 0, x: -30 },
      { autoAlpha: 1, x: 0, duration: 0.8 },
      "-=0.6"
    )
    .fromTo('.hero__nav',
      { autoAlpha: 0, x: 30 },
      { autoAlpha: 1, x: 0, duration: 0.8 },
      "-=0.6"
    )
    .fromTo('.hero .c-button',
      { autoAlpha: 0, y: 20 },
      { autoAlpha: 1, y: 0, duration: 0.6 },
      "-=0.6"
    )
    .fromTo('.hero__scroll',
      { autoAlpha: 0, y: -20 },
      { autoAlpha: 1, y: 0, duration: 0.6 },
      "-=0.4"
    );


  gsap.to(".hero", {
    opacity: 0,
    scrollTrigger: {
      trigger: ".hero",
      start: "top top",
      end: "+=100%",
      scrub: true
    }
  });
}

// Scroll Trigger Animations
const initScrollAnimations = () => {

}

const initEnterActive1 = () => {
  const enteractives1 = gsap.utils.toArray('.js-enter-active');
  if (!enteractives1) {
    return
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-active');
        // 一度だけ発火する場合は以下で監視を解除
        // observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1 // 10%以上表示されたら
  });
  enteractives1.forEach(target => {
    observer.observe(target);
  });
}


// Initialization
window.addEventListener('load', () => {
  // Clear initial CSS styles for GSAP to take over if needed, 
  // OR we rely on the fact that existing CSS sets them to opacity: 0
  // and GSAP .to() animates them to opacity: 1.
  // However, existing CSS has 'transition' properties which might conflict.
  // Ideally we remove CSS transitions for elements controlled by GSAP.
  
  gsap.set('.js-fade-in-up, .js-fade-in, .js-scale-in', { transition: 'none' });
  setTimeout(()=> {
    const hero = document.querySelector(".hero");
    hero.classList.add('is-active');
    initHeroAnimation();
  }, 2200)

  initScrollAnimations();
  initEnterActive1();
});



// window.scrollTo(0, 0)
let mm = gsap.matchMedia();
// initLoadingAnimation()
// initeParallaxAnimation(".js-parallax-wrapper")
mm.add('(min-width: ' + (breakPoint + 1) + 'px)', () => {
});
mm.add('(max-width: ' + (breakPoint) + 'px)', () => {
});

const resizeEvent = () => {
  gsap.delayedCall(0.2, ScrollTrigger.refresh);
}
if (!isSmartPhone()) {
  // initVanillaTilt();
  window.addEventListener('resize', resizeEvent)
}

const refbtns = document.querySelectorAll('.js-ref-btn')
if (refbtns) {
  refbtns.forEach((refbtn) => {
    refbtn.addEventListener('click', (e) => {
      gsap.delayedCall(0.2, ScrollTrigger.refresh);
    })
  })
}

